import dumpPipelineApi from './DumpPipelineAxios';

export async function getDumpStatus() {
    const { data } = await dumpPipelineApi.get('/dump/status');
    return data;
}

export async function getNextDumpWindow() {
    const { data } = await dumpPipelineApi.get('/dump/next-window');
    return data;
}

export async function getDumpBlockReasons(dataInicio, dataFim) {
    const { data } = await dumpPipelineApi.get('/dump/block-reasons', {
        params: { dataInicio, dataFim },
    });
    return data;
}

export async function listDumpJobs() {
    const { data } = await dumpPipelineApi.get('/dump');
    return data;
}

export async function startDump(dataInicio, dataFim) {
    const { data } = await dumpPipelineApi.post('/dump', {
        dataInicio,
        dataFim,
    });
    return data;
}

export async function pauseDump(jobId) {
    const { data } = await dumpPipelineApi.post(`/dump/${jobId}/pause`);
    return data;
}

export async function resumeDump(jobId) {
    const { data } = await dumpPipelineApi.post(`/dump/${jobId}/resume`);
    return data;
}

export async function getDumpLogs(jobId) {
    const { data } = await dumpPipelineApi.get(`/dump/${jobId}/logs`);
    return data;
}

export async function deleteDump(jobId) {
    const { data } = await dumpPipelineApi.delete(`/dump/${jobId}`);
    return data;
}
